import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=474cea42&"
import script from "./AuthStatus.vue?vue&type=script&lang=js&"
export * from "./AuthStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports